// apps/embed/src/chat-widget/ChatConnectionError.tsx
//
// Shown in the chat panel when the boot-time strings fetch fails — i.e. the
// widget cannot reach the API at all (local dev with `pnpm dev:api` not running,
// or a genuine TourTask outage). The copy is HARDCODED (English) on purpose:
// the API that serves UI translations is exactly what's unreachable, so a
// DB-backed translation would itself fall back to the raw key in the one moment
// it's needed. Without this, every label rendered the developer-facing
// `NO STRING IMPORTED WITH VAR NAME "…"` placeholder.

import { Box, Stack, Typography } from '@mui/material';
import { AlertBox } from '@tourtask/ui/components/AlertBox';
import { apiV1BaseUrl, isLocalDev } from '@tourtask/storefront/api/baseUrls';

export function ChatConnectionError() {
  return (
    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <AlertBox type="error" mb={0}>
        <Stack spacing={1.5}>
          <Typography variant="body2">
            We couldn&apos;t connect to the chat service. Please try again later.
          </Typography>
          {isLocalDev ? (
            // Dev-only: a real partner site never runs on `*.localhost`, so this
            // never reaches a visitor. It points the developer straight at the
            // cause — the local API isn't answering on the expected URL.
            <Typography variant="caption" color="text.secondary">
              Couldn&apos;t reach the API at <code>{apiV1BaseUrl}</code>. Start the
              local API with <code>pnpm dev:api</code>.
            </Typography>
          ) : null}
        </Stack>
      </AlertBox>
    </Box>
  );
}
